export type MenuItemType = {
    key: string;
    label: string;
    isTitle?: boolean;
    icon?: string;
    url?: string;
    badge?: {
        variant: string;
        text: string;
    };
    parentKey?: string;
    target?: string;
    children?: MenuItemType[];
};

const MENU_ITEMS: MenuItemType[] = [
    { key: 'vilacon', label: 'Vila Contábil', isTitle: true },
    {
        key: 'dashboards',
        label: 'Home',
        isTitle: false,
        icon: 'uil-home-alt',
        badge: { variant: 'success', text: '4' },
        url: `/dashboard/analytics`,
    },
    {
        key: 'triage',
        label: 'Triagem de Documentos',
        icon: 'uil-folder-check',
        url: `/triage`,
    }, 
    {
        key: 'taxclaimant',
        label: 'Declarantes',
        icon: 'dripicons-user',
        url: `/taxclaimant`,
    }
];

export { MENU_ITEMS };
